import { Trans, useLingui } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import Title from '@/design_system/Typography/Title';
import { getWorkflowTypeLabel, Workflow } from '@/models/workflow';

export const Type = ({ workflow }: { workflow: Workflow }) => {
  const { i18n } = useLingui();

  return (
    <Box gap="1rem">
      <Stack>
        <Title as="h2">
          <Trans id="settings.workflows.workflow.scope.type.title">Type</Trans>
        </Title>
        <Paragraph size="200" color="secondary">
          <Trans id="settings.workflows.workflow.scope.type.description">
            The type of applicant this workflow applies to.
          </Trans>
        </Paragraph>
      </Stack>
      <Paragraph size="100" color="secondary">
        {i18n._(getWorkflowTypeLabel(workflow.type))}
      </Paragraph>
    </Box>
  );
};
